/**
 * icons — set SVG coerente per la sidebar (e oltre).
 *
 * Sostituisce gli unicode/emoji piatti (☰ ✦ ◈ 🗺 📄) con icone in stile
 * Lucide: tratto pieno e arrotondato (stroke 2.25 → più "spesse"/moderne),
 * `currentColor` così ereditano il colore del testo del contesto.
 */

const PATHS: Record<string, string> = {
  // Autori → penna d'oca (scrittura) — default, sostituibile con libro/libreria
  authors:
    '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><path d="M16 8 2 22"/><path d="M17.5 15H9"/>',
  // Rete delle influenze → rete a triangolo (nodi connessi)
  influence:
    '<circle cx="12" cy="4.5" r="2.5"/><circle cx="5" cy="19" r="2.5"/><circle cx="19" cy="19" r="2.5"/><path d="M11 6.8 6 16.6"/><path d="m13 6.8 5 9.8"/><path d="M7.2 19h9.6"/>',
  // Mappa dei temi → livelli (layers)
  themeMap:
    '<path d="m12 2 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5"/><path d="m3 17 9 5 9-5"/>',
  // (metafore alternative Autori, pronte se servono)
  authorsBook: '<path d="M12 7v14"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/>',
  authorsLibrary: '<path d="m16 6 4 14"/><path d="M12 6v14"/><path d="M8 8v12"/><path d="M4 4v16"/>',
  // Toggle "Mappa" → mappa ripiegata
  map:
    '<path d="M14.5 4 9 6 3.7 4.2A1 1 0 0 0 2.3 5.1V18a1 1 0 0 0 .7 1L9 21l5.5-2 5.3 1.8a1 1 0 0 0 1.4-.9V6a1 1 0 0 0-.7-1z"/><path d="M9 6v15"/><path d="M14.5 4v15"/>',
  // Toggle "Testo" → righe di testo
  text:
    '<path d="M4 6h16"/><path d="M4 12h12"/><path d="M4 18h8"/>',
  // Chevron filtri (ruota in apertura)
  chevron: '<path d="m9 6 6 6-6 6"/>',
};

export function icon(name: string, size = 22): string {
  const d = PATHS[name] ?? '';
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
}
